import { COMPANY } from "@/data/content";
import { Section, Overline, usePageTitle } from "@/components/site/ui-bits";

const Block = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-bold text-slate-900 mb-3">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function MentionsLegales() {
  usePageTitle("Mentions légales");
  return (
    <div data-testid="mentions-legales-page">
      <section className="bg-gradient-to-b from-sky-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24 text-center">
          <Overline>Informations légales</Overline>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">Mentions légales</h1>
        </div>
      </section>

      <Section className="py-16">
        <div className="max-w-3xl mx-auto">
          <Block title="Éditeur du site">
            <p>Le présent site <b>{COMPANY.name.toLowerCase()}</b> (equinoxeproprete.fr) est édité par :</p>
            <p>
              <b>{COMPANY.name}</b>, filiale du {COMPANY.group}.<br />
              Forme juridique : Société par actions simplifiée (SAS) — Capital social : 200 €<br />
              Siège social : {COMPANY.addresses.join(" · ")}<br />
              SIREN / SIRET : 920 144 896<br />
              RCS et RM Cahors — N° TVA intracommunautaire : FR67920144896<br />
              Téléphone : {COMPANY.phone}
            </p>
          </Block>

          <Block title="Directeur de la publication">
            <p>Jean-Christophe VIRGO, représentant légal de {COMPANY.name}.</p>
          </Block>

          <Block title="Hébergement">
            <p>Le site est hébergé par :</p>
            <p>Equinoxe Studio<br />46250 Cazals, France</p>
          </Block>

          <Block title="Propriété intellectuelle">
            <p>
              L'ensemble des contenus présents sur ce site (textes, logos, visuels, éléments graphiques,
              charte visuelle) est la propriété exclusive de {COMPANY.name} ou de ses partenaires, et est
              protégé par les lois relatives à la propriété intellectuelle. Toute reproduction,
              représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite
              préalable est interdite.
            </p>
          </Block>

          <Block title="Données personnelles (RGPD)">
            <p>
              Les informations recueillies via les formulaires (demande de devis, message à un conseiller)
              sont destinées uniquement à {COMPANY.name} pour traiter votre demande et vous recontacter.
              Elles ne sont ni vendues ni cédées à des tiers.
            </p>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
              « Informatique et Libertés », vous disposez d'un droit d'accès, de rectification, de
              suppression et d'opposition sur vos données. Pour l'exercer, contactez-nous au {COMPANY.phone}
              {" "}ou via le formulaire de contact du site.
            </p>
          </Block>

          <Block title="Cookies">
            <p>
              Ce site peut utiliser des cookies techniques nécessaires à son bon fonctionnement. Vous pouvez
              configurer votre navigateur pour refuser les cookies non essentiels.
            </p>
          </Block>

          <Block title="Crédits">
            <p>
              Conception et réalisation :{" "}
              <a href="https://www.equinoxe.studio" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] font-semibold hover:underline">
                Equinoxe Studio
              </a>.
            </p>
          </Block>
        </div>
      </Section>
    </div>
  );
}
